import { Link, useNavigate, useParams } from "react-router-dom";
import { Col, Container, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../Service";
import { ForgotPassword, Href, Password } from "../../utils/Constant";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import apiRequestHelper from "../../utils/apiRequestHelper";
import { useAuth } from "../../context/AuthContext";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

const NewPassword = () => {
  const [show, setShow] = useState(false);
  const { token } = useParams();
  const [isTokenValid, setIsTokenValid] = useState(true);
  const navigate = useNavigate();
  const { loginUser } = useAuth();

  const validateToken = async () => {
    setIsTokenValid(true);
    try {
      await apiRequestHelper.post("/auth/validate-reset-password-token", {
        token,
      });
      setIsTokenValid(true);
    } catch (error: unknown) {
      setIsTokenValid(false);
    }
  };

  useEffect(() => {
    validateToken();
  }, [token]);

  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d\W]).+$/,
        "Password must include at least one lowercase, one uppercase letter, and one number or special character",
      )
      .required("New password is required"),
    confirmNewPassword: Yup.string()
      .oneOf([Yup.ref("newPassword")], "Passwords must match")
      .required("Please confirm your password"),
  });

  const handleSubmit = async (values: {
    newPassword: string;
    confirmNewPassword: string;
  }) => {
    try {
      const response = await apiRequestHelper.post("/auth/reset-password", {
        token,
        newPassword: values.newPassword,
        confirmNewPassword: values.confirmNewPassword,
      });

      toast.success(
        response?.data?.messages?.[0]?.message || "Password reset successfully",
      );
      navigate("/login");
    } catch (error: unknown) {
      const err = error as any;
      toast.error(
        err.response?.data?.messages?.[0]?.message || "An error occurred",
      );
    }
  };

  if (!isTokenValid) {
    return (
      <Container className="p-5 text-center">
        <H4>Invalid or expired reset token</H4>
        <Link to="/forgot-password">
          <Btn color="primary" className="mt-3">
            Request New Reset Link
          </Btn>
        </Link>
      </Container>
    );
  }

  return (
    <Container fluid className="p-0">
      <Row className="m-0">
        <Col xs="12" className="p-0">
          <div className="login-card login-dark">
            <video
              className="video-bg"
              playsInline
              autoPlay
              loop
              muted
              preload="auto"
            >
              <source src="/assets/images/asdad.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div>
              <div>
                <Link className="logo text-center position-relative" to={Href}>
                  <Image
                    className="img-fluid for-dark mx-auto"
                    style={{ width: "220px" }}
                    src={dynamicImage("logo.png")}
                    alt="loginpage"
                  />
                  <Image
                    className="img-fluid for-light mx-auto"
                    style={{ width: "220px" }}
                    src={dynamicImage("logo.png")}
                    alt="loginpage"
                  />
                </Link>
              </div>
              <div className="login-main position-relative">
                <Formik
                  initialValues={{ newPassword: "", confirmNewPassword: "" }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ isSubmitting }) => (
                    <Form className="theme-form">
                      <H4>New Password</H4>
                      <P>Enter your new password below</P>

                      <FormGroup>
                        <Label className="col-form-label">{Password}</Label>
                        <div className="form-input position-relative">
                          <Field
                            as={Input}
                            type={show ? "text" : "password"}
                            placeholder="*********"
                            name="newPassword"
                          />
                          <div
                            className="show-hide"
                            onClick={() => setShow(!show)}
                          >
                            <span className="show"></span>
                          </div>
                        </div>
                        <ErrorMessage
                          name="newPassword"
                          component="div"
                          className="text-danger"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label className="col-form-label">
                          {Password} (Confirm)
                        </Label>
                        <div className="form-input position-relative">
                          <Field
                            as={Input}
                            type={show ? "text" : "password"}
                            placeholder="*********"
                            name="confirmNewPassword"
                          />
                          <div
                            className="show-hide"
                            onClick={() => setShow(!show)}
                          >
                            <span className="show"></span>
                          </div>
                        </div>
                        <ErrorMessage
                          name="confirmNewPassword"
                          component="div"
                          className="text-danger"
                        />
                      </FormGroup>

                      <FormGroup className="mb-0 form-sub-title position-relative">
                        <Link className="forgot-link" to="/forgot-password">
                          {ForgotPassword}
                        </Link>
                        <div className="text-end mt-3">
                          <Btn
                            color="primary"
                            block
                            className="w-100"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? "Submitting..." : "Submit"}
                          </Btn>
                        </div>
                      </FormGroup>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NewPassword;
